import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="maps--search-state"
export default class extends Controller {
  connect() {
  }
}
